import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form, Field, FormikProps, ErrorMessage, FieldArray, FormikHelpers } from 'formik';
import { DatePicker } from 'formik-antd';
import { setGuardianshipStatementModalVisibleAction } from 'redux/actions/modal.action';
import Accordion from 'components/Accordion';
import { IBuildingInfoState, IBuildingInfoFormValue, Contract } from 'constants/models/components/insureProcessFire/buildingInfo';
import AddressComponent from 'components/AddressComponent';
import service from 'bff/services/fireProdService';
import apiCommonService from 'bff/services/commonService';
import _ from 'lodash';
import { RdStDataContent, SysOption } from 'bff/models/info';
import InputWithRegex from 'components/InputWithRegex';
import * as Yup from 'yup';
import FormikFocusError from 'components/FormikFocusError';
import commonService from 'utils/commonService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { YesNo, YesNoType } from 'constants/enums/yesNo.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import { Link } from 'bff/models/link';
// import PDFViewer from 'components/PDFViewer';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { SquareType } from 'constants/enums/squareType';
import { RootReducersState } from 'redux/reducers';
import { InsureTypesEnum } from 'constants/enums/insureTypes.enum';
import PDFAllPageViewer from 'components/PDFAllPageViewer';
import Modal from 'components/Modal';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import OTPVerificationForm from 'components/OTPVerificationForm';
import { MemberProfile } from 'bff/models/member';
import { SactionType } from 'constants/enums/sactionType.enum';
import { fetchMyFavorite } from 'redux/actions/components/myFavorite.action';

/** 網路續保身分驗證步驟 */
enum RenewalAuthStep {
  /** 身分驗證（輸入 ID + 手機） */
  Identity = 1,
  /** OTP 驗證碼輸入 */
  OTP = 2
}

/** 屋頂別-預設值 水泥平屋頂 (CF) */
const roofDefault = '';
/** 投保起日增加天數 */
const addDate = moment().hour() >= 12 ? 0 : -1;
/** 投保起日預設天數 */
const insureDateDefault = moment().hour() >= 12 ? moment().add(1, 'd') : moment();
/** 平方公尺換算坪數單位 */
const squeareMeterUnit = 0.3025;
/** 因應114年火險建築造價表改版 */
const referenceDate = moment('2025-01-01');
const initFormVal: IBuildingInfoFormValue = {
  INSURE_TYPE: InsureTypesEnum.Insure,
  REPOLICY_NO: '',
  POST_CODE: '',
  CITY_ID: '',
  CITY_NAME: '',
  AREA_ID: '',
  AREA_NAME: '',
  STREET_ID: '',
  STREET_ID_NAME: '',
  ADDRESS_ROADWAY: '',
  ADDRESS_ALLEY: '',
  ADDRESS_NUMBER: '',
  ADDRESS_NUMBER_OF: '',
  ADDRESS_FLOOR: '',
  ADDRESS_FLOOR_OF: '',
  ADDRESS_REMARK: '',
  FLOOR_TOTAL: '',
  BASEMENT_FLOOR_TOTAL: '',
  CURRENT_FLOOR: '1',
  SQUARE: '',
  SQUARE_FEET: '',
  SQUARE_UNIT: SquareType.Feet,
  BUILDING_STRUCTURE: '',
  BUILDING_STRUCTURE_NAME: '',
  ROOF_TYPE: roofDefault,
  ROOF_TYPE_NAME: '',
  CONSTRUCTION_YEAR: '',
  TRADE: '',
  DECORATION_COST: '',
  DECORATION_COST_NAME: '',
  INSURED_DATE: insureDateDefault,
  PROGRAM_ID: '',
  DECLARED: '',
  CONTRACTS: new Array(0),
  ALL_CONTRACT_CHECKED: false
};

let formInitialValues = initFormVal;

const formValidationSchema = Yup.object().shape({
  POST_CODE: Yup.string().required('標的物地址-郵遞區號為必填欄位').max(6, '郵遞區號長度不可超過 6 字元'),
  CITY_ID: Yup.string().required('標的物地址-縣、市為必填欄位'),
  AREA_ID: Yup.string().required('標的物地址-區域為必填欄位'),
  STREET_ID: Yup.string().required('標的物地址-道路為必填欄位'),
  ADDRESS_ROADWAY: Yup.string().test('range 1-9999', '標的物地址-巷，僅接受 1 ~ 9999 之數值', (val: string) => {
    if (val) {
      return /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])$/.test(val);
    }

    return true;
  }),
  ADDRESS_ALLEY: Yup.string().test('range 1-999', '標的物地址-弄，僅接受 1 ~ 999 之數值', (val: string) => {
    if (val) {
      return /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$/.test(val);
    }

    return true;
  }),
  ADDRESS_NUMBER: Yup.string().required('標的物地址-門牌號為必填欄位').test('range 1-9999', '標的物地址-門牌號，僅接受 1 ~ 9999 之數值', (val: string) => {
    if (val) {
      return /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])$/.test(val);
    }

    return true;
  }),
  ADDRESS_NUMBER_OF: Yup.string().test('range 1-9999', '標的物地址-門牌號之，僅接受 1 ~ 9999 之數值', (val: string) => {
    if (val) {
      return /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])$/.test(val);
    }

    return true;
  }),
  ADDRESS_FLOOR: Yup.string().test('range 1-101', '標的物地址-樓層，僅接受 1 ~ 101 之數值', (val: string) => {
    if (val) {
      return /^([1-9]|[1-9][0-9]|10[0-1])$/.test(val);
    }

    return true;
  }),
  ADDRESS_FLOOR_OF: Yup.string().test('range 1-999', '標的物地址-樓層之，僅接受 1 ~ 999 之數值', (val: string) => {
    if (val) {
      return /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$/.test(val);
    }

    return true;
  }),
  FLOOR_TOTAL: Yup.string().required('總樓層數-地上樓層為必填欄位').test('range 1-101', '總樓層數-地上樓層，僅接受 1 ~ 101 之數值', (val: string) => {
    if (val) {
      return /^([1-9]|[1-9][0-9]|10[0-1])$/.test(val);
    }

    return true;
  }).when('CURRENT_FLOOR', (currentFloor: string, schema: any) => {
    const floors = new Array(0);
    if (currentFloor && +currentFloor > 0) {
      for (let i = 1; i < +currentFloor; i += 1) {
        floors.push(`${i}`);
      }
    }
    return floors.length > 0 ? schema.notOneOf(floors, '總樓層數-所在樓層數，不可大於地上樓層數') : schema;
  }),
  BASEMENT_FLOOR_TOTAL: Yup.string().required('總樓層數-地下樓層為必填欄位').test('range 0-11', '總樓層數-地下樓層，僅接受 0 ~ 11 之數值', (val: string) => {
    if (val) {
      return /^([0-9]|1[0-1])$/.test(val);
    }

    return true;
  }),
  CURRENT_FLOOR: Yup.string().required('總樓層數-所在樓層為必填欄位').test('range 1-101', '總樓層數-所在樓層，僅接受 1 ~ 101 之數值', (val: string) => {
    if (val) {
      return /^([1-9]|[1-9][0-9]|10[0-1])$/.test(val);
    }

    return true;
  }).when('ADDRESS_FLOOR', (addressFloor: string, schema: any) => {
    return addressFloor ? schema.oneOf([addressFloor], '總樓層數-所在樓層，需和標的物地址-樓層一致') : schema;
  }),
  SQUARE: Yup.string().required('此為必填欄位')
    .test('format error', '輸入格式錯誤', (val: string) => {
      if (val) {
        return /^[\d]{0,4}(\.[\d]{1,5})?$/.test(val);
      }

      return true;
    }).test('custom validate', 'custom validate', function (val: string) {
      const { SQUARE_UNIT } = this.parent;
      if (val && +val === 0) return this.createError({ message: '不可為 0' });

      if (val && SQUARE_UNIT === SquareType.Meter && (Math.ceil(+val * squeareMeterUnit * 100) / 100) > 999) return this.createError({ message: '換算坪數大於最大坪數 999 請重新填寫' });

      if (val && SQUARE_UNIT === SquareType.Feet && (+val <= 0 || +val > 999)) {
        return this.createError({ message: '僅接受界於 0~999 之數值' });
      }

      return true;
    }),
  BUILDING_STRUCTURE: Yup.string().required('此為必填欄位'),
  ROOF_TYPE: Yup.string().required('此為必填欄位'),
  CONSTRUCTION_YEAR: Yup.string().required('此為必填欄位')
    .test('not zero', '不可為 0', (val: string) => {
      if (val) {
        return +val > 0;
      }
      return true;
    })
    .test('exceed year', '建造年份有誤，請確認', (val: string) => {
      if (val) {
        const sysYear = moment().year() - 1911;

        return +val <= sysYear;
      }

      return true;
    }),
  TRADE: Yup.string().required('此為必填欄位'),
  DECORATION_COST: Yup.string().required('此為必填欄位'),
  INSURED_DATE: Yup.string().required('此為必填欄位').nullable(),
  DECLARED: Yup.string().required('此為必填欄位')
});

class InsureProcessBuildingInfo extends React.Component<IProps, IBuildingInfoState> {
  private formikRef = React.createRef() as React.RefObject<FormikProps<IBuildingInfoFormValue>>;
  private decoCostOption: SysOption[];

  constructor (props: IProps) {
    super(props);
    this.decoCostOption = [];
  };

  state: IBuildingInfoState = {
    buildStructSysOpts: new Array(0),
    roofTypeSysOpts: new Array(0),
    decoCostSysOpts: new Array(0),
    yesnoSysOpts: new Array(0),
    docLinks: new Array(0),
    termStatus: new Array(0),
    renewalDataList: new Array(0),
    sysTime: 0,
    // 網路續保身分驗證 Modal
    showRenewalAuthModal: false,
    renewalAuthStep: RenewalAuthStep.Identity,
    renewalMemberId: '',
    renewalMobile: '',
    isMember: false,
    renewalOtpInfo: undefined,
    renewalGetOTPTime: undefined,
    renewalMemberIdVisible: false,
    renewalMemberIdError: '',
    renewalMobileError: ''
  }

  componentDidMount = async () => {
    commonService.scrollToTop();
    // 取得系統時間
    const serverTimeMs = await apiCommonService.fetchSysTime();
    const sysTime = Math.ceil(serverTimeMs / 1000);
    formInitialValues.INSURED_DATE = moment.unix(sysTime).hour() >= 12 ? moment.unix(sysTime).add(1, 'd') : moment.unix(sysTime);
    const initSetting = await service.fetchInitBuildingInfo();
    this.decoCostOption = initSetting.decoCostSysOpts;

    if (this.props.tempBuildingInfo && this.props.tempBuildingInfo.tempBuildingInfoFormValue && this.props.tempBuildingInfo.tempBuildingInfoState) {
      const { tempBuildingInfoFormValue, tempBuildingInfoState } = this.props.tempBuildingInfo;
      formInitialValues = {
        ...formInitialValues,
        ...tempBuildingInfoFormValue,
        PROGRAM_ID: tempBuildingInfoFormValue.PROGRAM_ID ? tempBuildingInfoFormValue.PROGRAM_ID : this.props.programId
      };
      this.setState({
        ...this.props.tempBuildingInfo.tempBuildingInfoState,
        decoCostSysOpts: this.props.tempBuildingInfo.tempBuildingInfoState.decoCostSysOpts,
        sysTime
      });

      return;
    }

    // 判斷是否登入完成
    let renewalDataListResp;
    if (this.props.fetchFavoriteComplete) {
      // 查詢續保資料
      renewalDataListResp = await this.handleFetchRenewalV2();
    }

    // 若有續保資料則帶入
    let targetRenewalData: any;
    let buildAddrsData: any;
    if (this.props.renewalInfo && renewalDataListResp) {
      targetRenewalData = renewalDataListResp.find((data) => data.policyNo === this.props.renewalInfo.POLICY_DATA.POLICY_NO);
      if (targetRenewalData) {
        const roofCode = targetRenewalData.roofCode === '1' ? '14' : targetRenewalData.roofCode;
        const structureInfo = _.find(initSetting.buildStructSysOpts, (sys: SysOption) => sys.PARAM_VALUE === targetRenewalData.structureCode);
        const roofTypeInfo = _.find(initSetting.roofTypeSysOpts, (sys: SysOption) => sys.PARAM_VALUE === roofCode);
        buildAddrsData = await this.fetchBuildAddr(this.props.renewalInfo.BUILDING_INFO.CITY_ID, this.props.renewalInfo.BUILDING_INFO.AREA_ID);
        // 街道名稱去除空白和特殊符號後比較
        const targetStreet = (this.props.renewalInfo.BUILDING_INFO.ADDRESS_RD_ST || '').replace(/[\s\-/•]/g, '');
        const streetId = buildAddrsData?.RD_ST_DATA.find((street: any) => {
          const cleanedRdSt = (street.RD_ST || '').replace(/[\s\-/•]/g, '');
          return cleanedRdSt && cleanedRdSt.includes(targetStreet);
        })?.RD_ST_ID;
        const addressLn = this.props.renewalInfo.BUILDING_INFO.ADDRESS_LN ? this.props.renewalInfo.BUILDING_INFO.ADDRESS_LN.toString() : '';
        const addressAly = this.props.renewalInfo.BUILDING_INFO.ADDRESS_ALY ? this.props.renewalInfo.BUILDING_INFO.ADDRESS_ALY.toString() : '';
        const addressNo = this.props.renewalInfo.BUILDING_INFO.ADDRESS_NO ? this.props.renewalInfo.BUILDING_INFO.ADDRESS_NO.toString().split('-') : [];
        const addressF = this.props.renewalInfo.BUILDING_INFO.ADDRESS_F ? this.props.renewalInfo.BUILDING_INFO.ADDRESS_F.toString().split('-') : [];
        formInitialValues = {
          ...formInitialValues,
          INSURE_TYPE: InsureTypesEnum.Renewal,
          REPOLICY_NO: this.props.renewalInfo.POLICY_DATA.POLICY_NO,
          CITY_ID: this.props.renewalInfo.BUILDING_INFO.CITY_ID,
          CITY_NAME: this.props.renewalInfo.BUILDING_INFO.CITY_NAME,
          AREA_ID: this.props.renewalInfo.BUILDING_INFO.AREA_ID,
          AREA_NAME: this.props.renewalInfo.BUILDING_INFO.AREA_NAME,
          POST_CODE: this.props.renewalInfo.BUILDING_INFO.POSTCODE,
          STREET_ID: streetId ?? '',
          STREET_ID_NAME: this.props.renewalInfo.BUILDING_INFO.ADDRESS_RD_ST,
          ADDRESS_ROADWAY: addressLn,
          ADDRESS_ALLEY: addressAly,
          ADDRESS_NUMBER: addressNo[0] ?? '',
          ADDRESS_NUMBER_OF: addressNo[1] ?? '',
          ADDRESS_FLOOR: addressF[0] ?? '',
          ADDRESS_FLOOR_OF: addressF[1] ?? '',
          INSURED_DATE: moment(targetRenewalData.expirateDate),
          FLOOR_TOTAL: String(targetRenewalData.upFloor),
          BASEMENT_FLOOR_TOTAL: String(targetRenewalData.downFloor),
          SQUARE: String(targetRenewalData.acreage),
          SQUARE_FEET: String(targetRenewalData.acreage),
          SQUARE_UNIT: SquareType.Feet,
          CONSTRUCTION_YEAR: targetRenewalData.buildingYear,
          CURRENT_FLOOR: targetRenewalData.floor && +targetRenewalData.floor > 0 ? targetRenewalData.floor : formInitialValues.CURRENT_FLOOR,
          BUILDING_STRUCTURE: structureInfo?.PARAM_VALUE || '',
          BUILDING_STRUCTURE_NAME: structureInfo?.PARAM_TEXT || '',
          ROOF_TYPE: roofTypeInfo?.PARAM_VALUE || roofDefault,
          ROOF_TYPE_NAME: roofTypeInfo?.PARAM_TEXT || '',
          TRADE: targetRenewalData.commercialBuilding === YesNoType.Yes ? YesNo.Yes : YesNo.No,
          DECORATION_COST: String(targetRenewalData.decorationCost),
          DECORATION_COST_NAME: initSetting.decoCostSysOpts.find((opt) => opt.PARAM_VALUE === String(targetRenewalData.decorationCost))?.PARAM_TEXT || ''
        };
      }
      // 查詢續保資料
      // this.handleFetchRenewal(formInitialValues.POST_CODE, formInitialValues.CITY_NAME, formInitialValues.AREA_NAME, formInitialValues.STREET_ID_NAME, formInitialValues.ADDRESS_NUMBER, formInitialValues.ADDRESS_NUMBER_OF, formInitialValues.ADDRESS_ROADWAY, formInitialValues.ADDRESS_ALLEY, formInitialValues.ADDRESS_FLOOR, formInitialValues.ADDRESS_FLOOR_OF);
    } else {
      formInitialValues = {
        ...formInitialValues,
        ROOF_TYPE_NAME: _.find(initSetting.roofTypeSysOpts, (sysOpt: SysOption) => sysOpt.PARAM_VALUE === roofDefault)?.PARAM_TEXT || ''
      };
    }

    // const initSetting = await service.fetchInitBuildingInfo();
    const contracts = this.handleGetContracts(initSetting.docLinks);

    formInitialValues = {
      ...formInitialValues,
      CONTRACTS: contracts,
      PROGRAM_ID: this.props.programId
    };

    const newState: any = {
      buildStructSysOpts: [...initSetting.buildStructSysOpts],
      decoCostSysOpts: referenceDate.isBefore(targetRenewalData?.expirateDate) ? this.decoCostOption : this.decoCostOption.slice(0, 7),
      roofTypeSysOpts: [...initSetting.roofTypeSysOpts],
      yesnoSysOpts: [...initSetting.yesnoSysOpts],
      docLinks: [...initSetting.docLinks],
      termStatus: commonService.getInitTermStatus(contracts),
      renewalFire: targetRenewalData,
      sysTime
    };

    if (buildAddrsData) {
      newState.buildAddrs = buildAddrsData;
    }

    this.setState(newState);
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values;

    this.props.onUnmount(formVal, this.state);

    formInitialValues = {
      ...initFormVal
    };
  }

  /**
   * @description 查詢建築物地址選項清單
   */
  fetchBuildAddr = async (cityId: string, areaId: string) => {
    const buildAddrs = await service.fetchBuildAddr(cityId, areaId);
    this.setState({ buildAddrs: buildAddrs });
    return buildAddrs;
  };

  /**
   * @description 取得要保人聲明事項初始值
  */
  handleGetContracts = (contractLinks: Link[]) => {
    const res = new Array(0);
    if (contractLinks && contractLinks.length > 0) {
      _.forEach(contractLinks, (contractLink: Link, index: number) => {
        res.push({
          LINK_NAME: contractLink.NAME,
          LINK_URL: contractLink.URL,
          CONTRACT: false
        });
      });
    }
    return res;
  }

  /**
   * @description 表單 Submit 事件
  */
  handleFormSubmit = async (values: IBuildingInfoFormValue, actions: FormikHelpers<IBuildingInfoFormValue>) => {
    storageService.removeItem(storageKeys.FireProgramCode);

    // 如有填入專案代碼，判斷專案代碼是否存在
    if (values.PROGRAM_ID) {
      const res = await apiCommonService.verifyProgramId(values.PROGRAM_ID, this.props.insTypeId);

      if (typeof res === 'string') {
        actions.setFieldError('PROGRAM_ID', res);
        return;
      }

      if (res && res.PROGRAM_ID) {
        storageService.setItem(storageKeys.FireProgramCode, res.PROGRAM_ID);
      }
    }

    // 建築物結構選擇其他，無法送出表單
    if (values.BUILDING_STRUCTURE === '99') {
      await sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W071)
      });
    }

    // 屋頂別選擇其他，無法送出表單
    if (values.ROOF_TYPE === '99') {
      await sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W072)
      });
    }

    if (values.BUILDING_STRUCTURE === '99' || values.ROOF_TYPE === '99') return;

    this.props.onSubmit(values, this.state);
  }

  /**
   * @description 地址-郵遞區號、縣市、區域 Change 事件
  */
  handleAddressChange = async (cityId: string, areaId: string) => {
    if (!this.formikRef || !this.formikRef.current) return;
    const setFieldValue = this.formikRef.current.setFieldValue;

    setFieldValue('STREET_ID', '');
    setFieldValue('STREET_ID_NAME', '');

    if (!cityId || !areaId) return;
    const buildAddrs = await service.fetchBuildAddr(cityId, areaId);
    if (!buildAddrs || !buildAddrs.RD_ST_DATA || buildAddrs.RD_ST_DATA.length === 0) {
      setFieldValue('STREET_ID', '');
      setFieldValue('STREET_ID_NAME', '');
    }

    this.setState({
      buildAddrs: buildAddrs
    });
  }

  /**
   * @description 查詢住火險續保件資料
   */
  handleFetchRenewal = _.debounce(async (
    postCode: string, cityName: string, areaName: string, streetName: string, number: string,
    numberOf: string = '', roadway: string = '', alley: string = '', floor: string = '', floorOf: string = ''
  ) => {
    if (!this.formikRef ||
      !this.formikRef.current ||
      !this.props.fetchFavoriteComplete ||
      !postCode ||
      !cityName ||
      !areaName ||
      !streetName ||
      !number
    ) return;

    // 取得完整地址
    const fullAddress = commonService.getFullAddress(
      '', cityName, areaName, streetName, roadway,
      alley, number, numberOf, floor, floorOf
    );

    const req = {
      ADDRESS: fullAddress
    };

    // 查詢續保資料
    const renewalRes = await service.renewalFire(req);
    if (!renewalRes || !renewalRes.DATA || Object.keys(renewalRes.DATA).length === 0) {
      const oldRenewal = { ...this.state.renewalFire };

      if (Object.keys(oldRenewal).length > 0) {
        this.formikRef.current.resetForm({
          values: {
            ...this.formikRef.current.values,
            FLOOR_TOTAL: '',
            BASEMENT_FLOOR_TOTAL: '',
            CURRENT_FLOOR: '1',
            SQUARE: '',
            SQUARE_FEET: '',
            SQUARE_UNIT: SquareType.Feet,
            BUILDING_STRUCTURE: '',
            BUILDING_STRUCTURE_NAME: '',
            ROOF_TYPE: roofDefault,
            ROOF_TYPE_NAME: '',
            CONSTRUCTION_YEAR: '',
            TRADE: '',
            DECORATION_COST: '',
            DECORATION_COST_NAME: '',
            INSURED_DATE: insureDateDefault,
            PROGRAM_ID: '',
            DECLARED: ''
          }
        });
      }

      this.setState({ renewalFire: null });
      return;
    }

    const renewalRoofCode = renewalRes.DATA.roofCode === '1' ? '14' : renewalRes.DATA.roofCode;
    const structureInfo = _.find(this.state.buildStructSysOpts, (sys: SysOption) => sys.PARAM_VALUE === renewalRes.DATA.structureCode);
    const roofTypeInfo = _.find(this.state.roofTypeSysOpts, (sys: SysOption) => sys.PARAM_VALUE === renewalRoofCode);

    const setFieldValue = this.formikRef.current.setFieldValue;
    setFieldValue('INSURED_DATE', moment(renewalRes.DATA.expirateDate));
    setFieldValue('FLOOR_TOTAL', renewalRes.DATA.upFloor);
    setFieldValue('BASEMENT_FLOOR_TOTAL', renewalRes.DATA.downFloor);
    setFieldValue('SQUARE', renewalRes.DATA.acreage);
    setFieldValue('SQUARE_FEET', renewalRes.DATA.acreage);
    setFieldValue('SQUARE_UNIT', SquareType.Feet);
    setFieldValue('CONSTRUCTION_YEAR', renewalRes.DATA.buildingYear);
    renewalRes.DATA.floor && +renewalRes.DATA.floor > 0 && setFieldValue('CURRENT_FLOOR', renewalRes.DATA.floor);
    setFieldValue('BUILDING_STRUCTURE', structureInfo?.PARAM_VALUE || '');
    setFieldValue('BUILDING_STRUCTURE_NAME', structureInfo?.PARAM_TEXT || '');
    setFieldValue('ROOF_TYPE', roofTypeInfo?.PARAM_VALUE || roofDefault);
    setFieldValue('ROOF_TYPE_NAME', roofTypeInfo?.PARAM_TEXT || '');

    this.setState({
      renewalFire: renewalRes
    });
  }, 2000)

  /**
   * @description 處理新保/續保 field onchange
   */
  handleInsureTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const decoCostOpts10 = this.decoCostOption;
    if (!this.formikRef || !this.formikRef.current) return;

    // 未登入且選擇續保時，彈出網路續保身分驗證 Modal
    if (event.target.value === InsureTypesEnum.Renewal && !this.props.fetchFavoriteComplete) {
      this.setState({
        showRenewalAuthModal: true,
        renewalAuthStep: RenewalAuthStep.Identity,
        renewalMemberId: '',
        renewalMobile: '',
        isMember: false
      });
      return;
    }

    if (event.target.value !== InsureTypesEnum.Renewal) {
      this.formikRef.current.setFieldValue('REPOLICY_NO', '');
      this.formikRef.current.setFieldValue('CITY_ID', '');
      this.formikRef.current.setFieldValue('AREA_ID', '');
      this.formikRef.current.setFieldValue('POST_CODE', '');
      this.setState(prev => ({
        ...prev,
        decoCostSysOpts: decoCostOpts10
      }));
    }
    if (event.target.value === InsureTypesEnum.Renewal) {
      this.formikRef.current.setFieldValue('INSURED_DATE', '');
      this.setState(prev => ({
        ...prev,
        decoCostSysOpts: decoCostOpts10
      }));
    } else {
      this.formikRef.current.setFieldValue('INSURED_DATE', '');
    }
    this.formikRef.current.handleChange(event);
  };

  /**
   * @description 關閉網路續保身分驗證 Modal
   */
  handleCloseRenewalAuthModal = () => {
    this.setState({
      showRenewalAuthModal: false,
      renewalAuthStep: RenewalAuthStep.Identity,
      renewalMemberId: '',
      renewalMobile: '',
      isMember: false,
      renewalOtpInfo: undefined,
      renewalGetOTPTime: undefined,
      renewalMemberIdVisible: false,
      renewalMemberIdError: '',
      renewalMobileError: ''
    });
  };

  getRenewalMemberIdError = (value: string) => {
    const memberId = value.replace(/\s/g, '');
    if (!memberId) return '此為必填欄位。';
    if (memberId.length !== 10) return '輸入帳號長度不可超過（少於）10 字元';
    return '';
  };

  getRenewalMobileError = (value: string) => {
    if (!value) return '此為必填欄位。';
    if (value.length !== 10) return '手機號碼長度為 10 字元';
    return '';
  };

  handleRenewalMemberIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const renewalMemberId = e.target.value.replace(/\s/g, '').toUpperCase();
    this.setState({
      renewalMemberId,
      renewalMemberIdError: this.state.renewalMemberIdError ? this.getRenewalMemberIdError(renewalMemberId) : ''
    });
  };

  handleRenewalMobileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const renewalMobile = e.target.value.replace(/\D/g, '');
    this.setState({
      renewalMobile,
      renewalMobileError: this.state.renewalMobileError ? this.getRenewalMobileError(renewalMobile) : ''
    });
  };

  handleRenewalAuthValidate = (renewalMemberId: string, renewalMobile: string) => {
    const renewalMemberIdError = this.getRenewalMemberIdError(renewalMemberId);
    const renewalMobileError = this.getRenewalMobileError(renewalMobile);

    this.setState({
      renewalMemberIdError,
      renewalMobileError
    });

    return !renewalMemberIdError && !renewalMobileError;
  };

  /**
   * @description 網路續保身分驗證 - 確認按鈕（查詢會員 + 發送 OTP）
   */
  handleRenewalAuthSubmit = async () => {
    const renewalMemberId = (this.state.renewalMemberId || '').replace(/\s/g, '').toUpperCase();
    const renewalMobile = (this.state.renewalMobile || '').replace(/\D/g, '');

    if (!this.handleRenewalAuthValidate(renewalMemberId, renewalMobile)) {
      return;
    }

    this.setState({ renewalMemberId, renewalMobile });

    // 查詢是否為網投會員
    let isMember = false;
    try {
      const memberRes = await apiCommonService.queryMemberForRenewal(renewalMemberId);
      if (memberRes && memberRes.IS_MEMBER_EXISTS) {
        isMember = true;
        // 若為網投會員，檢核手機號碼是否一致
        const memberProfile = memberRes.MEMBER && memberRes.MEMBER.length > 0 ? memberRes.MEMBER[0] : null;
        if (memberProfile && memberProfile.MOBILE !== renewalMobile) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            html: '輸入之資料與網投會員留存資料不同，請確認後重新輸入'
          });
          return;
        }
      }
    } catch {
      // 非網投會員，繼續進行
    }

    this.setState({ isMember });

    // 發送 OTP
    const sactionType = isMember ? SactionType.Login : SactionType.RenewalVerify;
    const result = await apiCommonService.fetchOTP(
      { MEMBER_ID: renewalMemberId, MOBILE: renewalMobile, EMAIL_ADDR: '' } as MemberProfile,
      sactionType
    );

    if (result) {
      this.setState({
        renewalAuthStep: RenewalAuthStep.OTP,
        renewalOtpInfo: { ...result.TRANRS },
        renewalGetOTPTime: new Date().getTime()
      });
    }
  };

  /**
   * @description 網路續保身分驗證 - 重新發送 OTP
   */
  handleRenewalResendOTP = async () => {
    const { renewalMemberId, renewalMobile, isMember } = this.state;
    const sactionType = isMember ? SactionType.Login : SactionType.RenewalVerify;
    const result = await apiCommonService.fetchOTP(
      { MEMBER_ID: renewalMemberId, MOBILE: renewalMobile, EMAIL_ADDR: '' } as MemberProfile,
      sactionType,
      true
    );

    if (result) {
      this.setState({
        renewalOtpInfo: { ...result.TRANRS },
        renewalGetOTPTime: new Date().getTime()
      });
    }
  };

  /**
   * @description 網路續保身分驗證 - 驗證 OTP
   */
  handleRenewalVerifyOTP = async (otpCode: string) => {
    const { renewalOtpInfo, isMember, renewalMemberId, renewalMobile } = this.state;
    if (!renewalOtpInfo) return;

    const sactionType = isMember ? SactionType.Login : SactionType.RenewalVerify;
    const createToken = isMember;
    const result = await apiCommonService.verifyOTP(renewalOtpInfo, otpCode, sactionType, createToken);

    if (typeof result === 'string') {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '驗證碼輸入有誤'
      });
      return;
    }

    if (!result) return;

    // 若為網投會員，設定登入狀態
    if (isMember && result) {
      storageService.removeItem(storageKeys.MemberId);
      storageService.removeItem(storageKeys.LoginInfo);
      commonService.storageData(storageKeys.MemberId, renewalMemberId);
      commonService.storageData(storageKeys.LoginInfo, result);
      this.props.dispatchFetchMyFavorite(renewalMemberId!);
    }

    // 查詢續保資料
    const renewalReq = isMember
      ? { ID_NO: renewalMemberId }
      : { ID_NO: renewalMemberId, PHONE_NO: renewalMobile };
    const renewalRes = await service.renewalFireV2(renewalReq);

    // 如果返回 undefined，表示已顯示過錯誤訊息，直接關閉 Modal
    if (!renewalRes) {
      this.handleCloseRenewalAuthModal();
      return;
    }

    if (!renewalRes.DATA || renewalRes.DATA.length === 0) {
      this.handleCloseRenewalAuthModal();
      return;
    }

    // 續保資料帶入
    this.setState({
      renewalDataList: renewalRes.DATA,
      showRenewalAuthModal: false,
      renewalAuthStep: RenewalAuthStep.Identity
    }, () => {
      // 切換為續保模式 - 在 state 更新完後執行
      if (this.formikRef && this.formikRef.current) {
        this.formikRef.current.setFieldValue('INSURE_TYPE', InsureTypesEnum.Renewal);
      }
    });
  };

  /**
   * @description 網路續保身分驗證 - 返回身分驗證頁
   */
  handleRenewalAuthGoBack = () => {
    this.setState({
      renewalAuthStep: RenewalAuthStep.Identity,
      renewalOtpInfo: undefined,
      renewalGetOTPTime: undefined
    });
  };

  /**
   * @description 查詢住火險續保件資料
   */
  handleFetchRenewalV2 = async () => {
    const renewalRes = await service.renewalFireV2({ ID_NO: storageService.getItem(storageKeys.MemberId) });
    if (!renewalRes || !renewalRes.DATA || renewalRes.DATA.length === 0) return;
    this.setState({ renewalDataList: renewalRes.DATA });
    return renewalRes.DATA;
  };

  /**
   * @description 解析地址字符串提取路、巷、弄、號、樓等信息
   */
  parseAddress3 = (address3: string) => {
    const result = {
      street: '', // 道路名稱
      roadway: '', // 巷號
      alley: '', // 弄號
      number: '', // 號
      numberOf: '', // 之號
      floor: '', // 樓
      floorOf: '' // 樓之
    };

    if (!address3) return result;

    // 提取道路名稱（如：中正路、中正街等）
    const streetMatch = address3.match(/^[^路街]*[路街]/);
    if (streetMatch) {
      result.street = streetMatch[0].trim();
    }

    // 提取 路/街 後的數字 (ADDRESS_ROADWAY - 巷號)
    const roadwayMatch = address3.match(/[路街](\d+)/);
    if (roadwayMatch) {
      result.roadway = roadwayMatch[1];
    }

    // 提取 巷 和 弄 的數字 (ADDRESS_ALLEY - 弄號)
    // 只在地址中包含「弄」字時才提取弄號，避免把號當作弄號
    const alleyMatch = address3.match(/巷(\d+)弄/);
    if (alleyMatch) {
      result.alley = alleyMatch[1];
    }

    // 提取 號 前後的數字 (ADDRESS_NUMBER 和 ADDRESS_NUMBER_OF)
    // 格式：數字號 或 數字號之數字（如：3號之34）或 巷之數字（如：巷之12）
    // 注意：處理 巷X號、巷X弄Y號、巷之X 的情況

    if (address3.includes('號')) {
      // 有號字的情況
      if (address3.includes('弄')) {
        // 有弄字：格式為 巷X弄Y號，號前的數字是 Y
        const withAlleyMatch = address3.match(/弄(\d+)號/);
        if (withAlleyMatch) {
          result.number = withAlleyMatch[1];
        }
      } else {
        // 無弄字：格式為 巷X號 或 路X號，號前的數字是 X
        const simpleMatch = address3.match(/巷(\d+)號|路\d+巷(\d+)號/);
        if (simpleMatch) {
          result.number = simpleMatch[1] || simpleMatch[2];
        }
      }
      // 提取之號（號之X）
      const numberOfMatch = address3.match(/號之(\d+)/);
      if (numberOfMatch) {
        result.numberOf = numberOfMatch[1];
      }
    } else if (address3.includes('巷之')) {
      // 無號字但有「巷之」的情況（如：中正路256巷之12）
      // 直接把之後的數字作為 numberOf
      const directNumberOfMatch = address3.match(/巷之(\d+)/);
      if (directNumberOfMatch) {
        result.numberOf = directNumberOfMatch[1];
      }
    }

    // 提取 樓 前後的數字 (ADDRESS_FLOOR 和 ADDRESS_FLOOR_OF)
    // 格式：樓數字 或 樓數字之數字（如：5樓之8）
    // 注意：地址可能包含逗號分隔，如「號之34，12樓之1」
    const floorMatch = address3.match(/(?:，\s*)?(\d+)樓(?:之(\d+))?/);
    if (floorMatch) {
      result.floor = floorMatch[1];
      result.floorOf = floorMatch[2] || '';
    }

    return result;
  };

  /**
   * @description 帶入住火險續保件資料
   */
  handleBringRenewal = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const decoCostOpts6 = this.decoCostOption.slice(0, 7);
    const decoCostOpts10 = this.decoCostOption;
    if (!this.formikRef || !this.formikRef.current) return;
    const targetRenewalData = this.state.renewalDataList.find((data) => data.policyNo === event.target.value);
    if (targetRenewalData) {
      // 去除 zipCode 的空格
      const zipCode = targetRenewalData.zipCode?.trim() || '';
      const cityId = this.props.postcodes.find((city) => city.AREA.some((area) => area.POST_CODE === zipCode))?.CITY_ID;
      const areaId = this.props.postcodes.find((city) => city.AREA.find((area) => area.POST_CODE === zipCode))?.AREA.find((area) => area.POST_CODE === zipCode)?.AREA_ID;
      const buildAddrs = (cityId && areaId) ? await service.fetchBuildAddr(cityId, areaId) : null;
      const roofCode = targetRenewalData.roofCode === '1' ? '14' : targetRenewalData.roofCode;
      const structureInfo = _.find(this.state.buildStructSysOpts, (sys: SysOption) => sys.PARAM_VALUE === targetRenewalData.structureCode);
      const roofTypeInfo = _.find(this.state.roofTypeSysOpts, (sys: SysOption) => sys.PARAM_VALUE === roofCode);
      const setFieldValue = this.formikRef.current.setFieldValue;

      // 解析地址字符串
      const addressParts = this.parseAddress3(targetRenewalData.address3);

      if (cityId) {
        setFieldValue('CITY_ID', cityId);
        const cityName = this.props.postcodes.find(item => item.CITY_ID === cityId)?.CITY_NAME;
        if (cityName) setFieldValue('CITY_NAME', cityName);
      };
      if (areaId) {
        setFieldValue('AREA_ID', areaId);
        const areaArray = this.props.postcodes.find(item => item.CITY_ID === cityId)?.AREA;
        if (areaArray) {
          const areaName = areaArray.find(item => item.AREA_ID === areaId)?.AREA_NAME;
          setFieldValue('AREA_NAME', areaName);
        }
      };
      setFieldValue('POST_CODE', zipCode);

      // 帶入解析後的地址信息
      // 道路名稱 - 從 buildAddrs 中查找對應的 STREET_ID（去除空白和特殊符號後比較）
      if (addressParts.street && buildAddrs && buildAddrs.RD_ST_DATA && buildAddrs.RD_ST_DATA.length > 0) {
        const cleanedStreet = addressParts.street.replace(/[\s\-/•]/g, '');
        const streetMatch = buildAddrs.RD_ST_DATA.find((addr: any) => {
          const cleanedRdSt = (addr.RD_ST || '').replace(/[\s\-/•]/g, '');
          return cleanedRdSt && cleanedRdSt.includes(cleanedStreet);
        });
        if (streetMatch) {
          setFieldValue('STREET_ID', streetMatch.RD_ST_ID);
          setFieldValue('STREET_ID_NAME', streetMatch.RD_ST);
        }
      }

      if (addressParts.roadway) setFieldValue('ADDRESS_ROADWAY', addressParts.roadway);
      if (addressParts.alley) setFieldValue('ADDRESS_ALLEY', addressParts.alley);
      if (addressParts.number) setFieldValue('ADDRESS_NUMBER', addressParts.number);
      if (addressParts.numberOf) setFieldValue('ADDRESS_NUMBER_OF', addressParts.numberOf);
      if (addressParts.floor) setFieldValue('ADDRESS_FLOOR', addressParts.floor);
      if (addressParts.floorOf) setFieldValue('ADDRESS_FLOOR_OF', addressParts.floorOf);
      setFieldValue('INSURED_DATE', moment(targetRenewalData.expirateDate));
      setFieldValue('FLOOR_TOTAL', targetRenewalData.upFloor);
      setFieldValue('BASEMENT_FLOOR_TOTAL', targetRenewalData.downFloor);
      setFieldValue('SQUARE', targetRenewalData.acreage);
      setFieldValue('SQUARE_FEET', targetRenewalData.acreage);
      setFieldValue('SQUARE_UNIT', SquareType.Feet);
      setFieldValue('CONSTRUCTION_YEAR', targetRenewalData.buildingYear);
      targetRenewalData.floor && +targetRenewalData.floor > 0 && setFieldValue('CURRENT_FLOOR', targetRenewalData.floor);
      setFieldValue('BUILDING_STRUCTURE', structureInfo?.PARAM_VALUE || '');
      setFieldValue('BUILDING_STRUCTURE_NAME', structureInfo?.PARAM_TEXT || '');
      setFieldValue('ROOF_TYPE', roofTypeInfo?.PARAM_VALUE || roofDefault);
      setFieldValue('ROOF_TYPE_NAME', roofTypeInfo?.PARAM_TEXT || '');
      setFieldValue('TRADE', targetRenewalData.commercialBuilding === YesNoType.Yes ? YesNo.Yes : YesNo.No);
      // 裝潢費用：若 API 返回 null，則不赋值（保持原有选择）
      if (targetRenewalData.decorationCost !== null && targetRenewalData.decorationCost !== undefined) {
        setFieldValue('DECORATION_COST', String(targetRenewalData.decorationCost));
      }
      this.setState({ renewalFire: targetRenewalData, ...(buildAddrs && { buildAddrs }) });
      if (moment(targetRenewalData.expirateDate).isBefore(referenceDate)) {
        this.setState(prev => ({
          ...prev,
          decoCostSysOpts: decoCostOpts6
        }));
      }
      if (moment(targetRenewalData.expirateDate).isAfter(referenceDate)) {
        this.setState(prev => ({
          ...prev,
          decoCostSysOpts: decoCostOpts10
        }));
      }
    }
    this.formikRef.current.handleChange(event);
  };

  /**
   * @description 取得預覽地址
   */
  handleGetPreveiwAddress = (
    postCode: string = '', cityName: string = '', areaName: string = '', streetName: string = '', roadway: string = '',
    alley: string = '', number: string = '', numberOf: string = '', floor: string = '', floorOf: string = ''
  ) => {
    // 取得完整地址
    let fullAddress = `${postCode}${cityName}${areaName}${streetName}`;
    if (roadway) {
      fullAddress = `${fullAddress}${roadway}巷`;
    }

    if (alley) {
      fullAddress = `${fullAddress}${alley}弄`;
    }

    if (number && numberOf) {
      fullAddress = `${fullAddress}${number}號之${numberOf}`;
    }

    if (number && !numberOf) {
      fullAddress = `${fullAddress}${number}號`;
    }

    if (floor && numberOf) {
      fullAddress = `${fullAddress}，${floor}樓`;
    }

    if (floor && !numberOf) {
      fullAddress = `${fullAddress}${floor}樓`;
    }

    if (floorOf) {
      fullAddress = `${fullAddress}之${floorOf}`;
    }

    return fullAddress ? `地址預覽：${fullAddress}` : '';
  }

  /**
  * @description 建立相關條款文件內容區塊
  */
  handleCreateContractArea = (values: IBuildingInfoFormValue, setFieldValue: any) => {
    if (this.state.docLinks.length === 0) return;

    const child = _.map(this.state.docLinks, (docLink: Link, index: number) => {
      return (
        <Accordion.Item
          key={index}
          updateStatus={(openVal: any) => {
            // 更新條款狀態
            this.setState({
              termStatus: commonService.headerClickUpdateTermStatus(openVal, index, this.state.termStatus)
            });
          }}
          isActive={commonService.setPDFOpen(index, this.state.termStatus)}
        >
          {docLink.URL.includes('.pdf') ? (
            <Accordion.Header title={docLink.NAME}>
              <button
                type="button"
                disabled={values.DECLARED === YesNo.Yes}
                className="review-terms__download-btn"
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => this.handleDownloadFile(event, docLink.URL, docLink.NAME)}
              />
            </Accordion.Header>
          ) : (
            <Accordion.Header title={docLink.NAME} link={docLink.URL} />
          )}
          <Accordion.Content>
            {docLink.URL.includes('.pdf') && (
              <PDFAllPageViewer
                url={docLink.URL}
                show={commonService.setPDFOpen(index, this.state.termStatus) || false}
                updateStatus={(bottom: any) => {
                // 更新條款狀態
                  this.setState((prev: any) => ({
                    ...prev,
                    termStatus: commonService.headerScrollUpdateTermStatus(bottom, index, this.state.termStatus)
                  }));
                }}
                checkContracts={values.DECLARED !== YesNo.Yes ? () => {
                  setFieldValue(`CONTRACTS[${index}].CONTRACT`, true);
                  apiCommonService.fetchSysTime().then((res: any) => {
                    setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, res);
                  });
                } : () => {}}
              />
            )}
          </Accordion.Content>
          <Accordion.Addition>
            <div className="element__checkbox-group">
              <label htmlFor={`statement-checkbox${index + 1}`}>
                <div className="element__checkbox">
                  <Field
                    disabled={values.DECLARED === YesNo.Yes || commonService.setPDFCheckable(index, this.state.termStatus)}
                    type="checkbox"
                    name={`CONTRACTS[${index}].CONTRACT`}
                    id={`statement-checkbox${index + 1}`}
                    onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                      if (e.currentTarget.checked) {
                        apiCommonService.fetchSysTime().then((res: any) => {
                          setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, res);
                        });
                      }

                      if (!e.currentTarget.checked) {
                        setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, null);
                        setFieldValue('ALL_CONTRACT_CHECKED', false);
                        setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
                      }

                      // 更新狀態
                      this.setState({
                        termStatus: commonService.updateTermStatus(e.currentTarget.checked, index, this.state.termStatus)
                      });
                    }}
                  />
                  <div className="element__checkbox-btn" />
                </div>
                <span>審閱條款</span>
              </label>
            </div>
          </Accordion.Addition>
        </Accordion.Item>
      );
    });
    return (
      <Accordion>
        {child}
      </Accordion>
    );
  }

  /**
   * @description 根據路徑下載檔案
  */
  handleDownloadFile = (event: React.MouseEvent<HTMLButtonElement>, linkUrl: string, fileName: string) => {
    event.stopPropagation();
    try {
      commonService.downloadFile(linkUrl, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  };

  /**
   * @description 使用面積單位 Click 事件
   */
  handleSquareUnitClick = (val: string, unitVal: string, squareVal: string, setFieldValue: any, setFieldTouched: any) => {
    setFieldTouched('SQUARE', true);
    if (val === unitVal) return;

    this.handleSquareChange(squareVal, val, setFieldValue);
  }

  /**
 * @description 使用面積單位 Click 事件
 */
  handleSquareChange = (val: string, unitVal: string, setFieldValue: any) => {
    if (val && unitVal === SquareType.Meter) {
      setFieldValue('SQUARE_FEET', `${this.getMathCeil(+val * squeareMeterUnit)}`);
      return;
    }

    if (val && unitVal === SquareType.Feet) {
      setFieldValue('SQUARE', this.getMathCeil(+val));
      setFieldValue('SQUARE_FEET', this.getMathCeil(+val));
      return;
    }

    setFieldValue('SQUARE_FEET', '0');
  }

  /**
   * @description 取得無條件進位至小數點第二位值
   */
  getMathCeil = (val: number) => {
    // return Math.floor(val * 100) / 100;
    const re = /([0-9]+\.[0-9]{2})[0-9]*/;
    const aNew = val.toString().replace(re, '$1');
    return +aNew;
  }

  /**
   * @description 從 server 取得時間
   */
  getSysTime = async () => {
    const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
    this.setState(prevState => {
      return {
        ...prevState,
        sysTime: sysTime
      };
    });
  }

  render () {
    // #region 取得街道下拉選單

    let streetOpts: any;
    if (this.state.buildAddrs && this.state.buildAddrs.RD_ST_DATA && this.state.buildAddrs.RD_ST_DATA.length > 0) {
      streetOpts = _.map(this.state.buildAddrs.RD_ST_DATA, (rdStDataContent: RdStDataContent, index: number) => {
        return <option key={index} value={rdStDataContent.RD_ST_ID}>{rdStDataContent.RD_ST}</option>;
      });
    }

    // #endregion

    // #region 取得建築物結構下拉選單

    let buildStructOpts: any;
    if (this.state.buildStructSysOpts.length > 0) {
      buildStructOpts = _.map(this.state.buildStructSysOpts, (sysOpt: SysOption, index: number) => {
        return <option key={index} value={sysOpt.PARAM_VALUE}>{sysOpt.PARAM_TEXT}</option>;
      });
    }

    // #endregion

    // #region 取得屋頂別下拉選單

    let roofTypeOpts: any;
    if (this.state.roofTypeSysOpts.length > 0) {
      roofTypeOpts = _.map(this.state.roofTypeSysOpts, (sysOpt: SysOption, index: number) => {
        return <option key={index} value={sysOpt.PARAM_VALUE}>{sysOpt.PARAM_TEXT}</option>;
      });
    }

    // #endregion

    // #region 建立是否有營業選項

    const handleCreateTradeRadios = (values: IBuildingInfoFormValue) => {
      if (this.state.yesnoSysOpts.length === 0) return;

      return _.map(this.state.yesnoSysOpts, (sysOpt: SysOption, index: number) => {
        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`trade-${sysOpt.PARAM_VALUE}-radio`}>
              <div className="element__radio">
                <Field type="radio" name="TRADE" id={`trade-${sysOpt.PARAM_VALUE}-radio`} value={sysOpt.PARAM_VALUE} disabled={values.DECLARED === YesNo.Yes} />
                <div className="element__radio-btn" />
              </div>
              <span>{sysOpt.PARAM_TEXT}</span>
            </label>
          </div>
        );
      });
    };

    // 取得裝潢費用下拉選單
    const decoCostOpts6 = this.decoCostOption.slice(0, 7);
    const decoCostOpts10 = this.decoCostOption;

    // #region 建立是否受監護宣告選項

    let declareRadios: any;
    if (this.state.yesnoSysOpts.length > 0) {
      declareRadios = _.map(this.state.yesnoSysOpts, (sysOpt: SysOption, index: number) => {
        return (
          React.cloneElement(
            <>
              <div className="element__radio-group">
                <label htmlFor={`declared-radio-${sysOpt.PARAM_VALUE}`}>
                  <div className="element__radio">
                    <Field type="radio" name="DECLARED" id={`declared-radio-${sysOpt.PARAM_VALUE}`} value={sysOpt.PARAM_VALUE} />
                    <div className="element__radio-btn" />
                  </div>
                  <span>{sysOpt.PARAM_TEXT}</span>
                </label>
              </div>
            </>
            , { key: index }
          )
        );
      });
    }

    // #endregion

    return (
      <div className="insure-process-building-info">
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={this.handleFormSubmit}
          innerRef={this.formikRef as any}
          enableReinitialize
        >
          {({ values, errors, touched, handleBlur, handleChange, setFieldValue, setFieldTouched }) => (
            <Form>
              <div className="insure-process-building-info__content">
                {/* 建築物資料 */}
                <div className="building-info">
                  <div className="building-info__title">建築物資料</div>
                  <div className="building-info__content">
                    <div className="building-info__row">
                      <div id="insure-type-form-group" className="element__form-group">
                        <div className="element__form-group-title">
                          <span className="insure-type-highlight">{commonService.htmlParser(commonService.getCodeMsg(this.props.UICodes, CodeId.U041))}</span>
                        </div>
                        <div className="element__form-group-content">
                          <span>我要</span>
                          <div className="element__radio-group">
                            <label>
                              <div className="element__radio">
                                <Field
                                  type="radio"
                                  name="INSURE_TYPE"
                                  value={InsureTypesEnum.Insure}
                                  onChange={this.handleInsureTypeChange}
                                />
                                <div className="element__radio-btn" />
                              </div>
                              <span>新保</span>
                            </label>
                          </div>
                          <div className="element__radio-group">
                            <label>
                              <div className="element__radio">
                                <Field
                                  type="radio"
                                  name="INSURE_TYPE"
                                  value={InsureTypesEnum.Renewal}
                                  onChange={this.handleInsureTypeChange}
                                  disabled={this.props.fetchFavoriteComplete && this.state.renewalDataList.length === 0}
                                />
                                <div className="element__radio-btn" />
                              </div>
                              <span>續保</span>
                              <Field
                                as="select"
                                name="REPOLICY_NO"
                                className="element__select"
                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                  this.handleBringRenewal(e);
                                  handleChange('REPOLICY_NO')(e);
                                }}
                                disabled={!(values.INSURE_TYPE === InsureTypesEnum.Renewal && this.state.renewalDataList.length > 0)}
                              >
                                <option value="">請選擇</option>
                                {this.state.renewalDataList.map((data, index) => (
                                  <option value={data.policyNo} key={index}>
                                    {data.fullAddress}
                                  </option>
                                ))}
                              </Field>
                            </label>
                          </div>
                        </div>
                        <div className="element__error-message" />
                      </div>
                    </div>
                    <div className="building-info__row">
                      {/* 標的物地址 */}
                      <div
                        className={'element__form-group' + (
                          (errors.POST_CODE && touched.POST_CODE) ||
                            (errors.CITY_ID && touched.CITY_ID) ||
                            (errors.AREA_ID && touched.AREA_ID) ||
                            (errors.STREET_ID && touched.STREET_ID) ||
                            (errors.ADDRESS_ROADWAY && touched.ADDRESS_ROADWAY) ||
                            (errors.ADDRESS_ALLEY && touched.ADDRESS_ALLEY) ||
                            (errors.ADDRESS_NUMBER && touched.ADDRESS_NUMBER) ||
                            (errors.ADDRESS_FLOOR && touched.ADDRESS_FLOOR)
                            ? ' element__form-group--invalid'
                            : '')}
                        id="address-form-group"
                      >
                        <div className="element__form-group-title">標的物地址*
                          <span className="address-remind-highlight">{commonService.getCodeMsg(this.props.UICodes, CodeId.U037)}</span>
                        </div>
                        <div className="element__form-group-content">
                          <AddressComponent
                            postCodeName="POST_CODE"
                            postCodeId="post-code-input"
                            postCodeIdTabIndex={1}
                            cityIdName="CITY_ID"
                            cityId="city-select"
                            cityIdVal={values.CITY_ID}
                            cityIdText="CITY_NAME"
                            cityIdTabIndex={2}
                            areaIdName="AREA_ID"
                            areaId="area-select"
                            areaIdVal={values.AREA_ID}
                            areaIdText="AREA_NAME"
                            areaNameVal={values.AREA_NAME}
                            areaIdTabIndex={3}
                            hideAddress
                            postcodes={this.props.postcodes}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                            onAddressChange={this.handleAddressChange}
                            disabled={values.DECLARED === YesNo.Yes}
                          />
                          <Field
                            as="select"
                            name="STREET_ID"
                            tabIndex={4}
                            data-fieldname="STREET_ID"
                            id="street-select"
                            className="element__select"
                            disabled={values.DECLARED === YesNo.Yes}
                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                              const textVal = e.currentTarget.selectedOptions.item(0)?.text || '';
                              commonService.setSelectOptName(setFieldValue, 'STREET_ID_NAME', textVal);
                              // 查詢續保資料
                              // this.handleFetchRenewal(
                              //   values.POST_CODE, values.CITY_NAME, values.AREA_NAME, textVal, values.ADDRESS_NUMBER,
                              //   values.ADDRESS_NUMBER_OF, values.ADDRESS_ROADWAY, values.ADDRESS_ALLEY, values.ADDRESS_FLOOR,
                              //   values.ADDRESS_FLOOR_OF
                              // )
                              handleChange('STREET_ID')(e);
                            }}
                          >
                            <option value="">請選擇</option>
                            {streetOpts}
                          </Field>
                          <Field
                            component={InputWithRegex}
                            name="ADDRESS_ROADWAY"
                            tabIndex={5}
                            data-fieldname="ADDRESS_ROADWAY"
                            maxLength={4}
                            autoComplete="off"
                            id="address-roadway-input"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('ADDRESS_ROADWAY', true);
                            }}
                            onChange={(val: string) => {
                              // 查詢續保資料
                              // this.handleFetchRenewal(
                              //   values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_NUMBER,
                              //   values.ADDRESS_NUMBER_OF, val, values.ADDRESS_ALLEY, values.ADDRESS_FLOOR,
                              //   values.ADDRESS_FLOOR_OF
                              // )
                              handleChange('ADDRESS_ROADWAY')(val);
                            }}
                          />
                          <span>巷</span>
                          <Field
                            component={InputWithRegex}
                            name="ADDRESS_ALLEY"
                            tabIndex={6}
                            data-fieldname="ADDRESS_ALLEY"
                            maxLength={3}
                            autoComplete="off"
                            id="address-alley-input"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('ADDRESS_ALLEY', true);
                            }}
                            onChange={(val: string) => {
                              // 查詢續保資料
                              // this.handleFetchRenewal(
                              //   values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_NUMBER,
                              //   values.ADDRESS_NUMBER_OF, values.ADDRESS_ROADWAY, val, values.ADDRESS_FLOOR,
                              //   values.ADDRESS_FLOOR_OF
                              // )
                              handleChange('ADDRESS_ALLEY')(val);
                            }}
                          />
                          <span>弄</span>
                          <Field
                            component={InputWithRegex}
                            regex={/^[\d]{0,4}$/}
                            name="ADDRESS_NUMBER"
                            tabIndex={7}
                            data-fieldname="ADDRESS_NUMBER"
                            maxLength={4}
                            autoComplete="off"
                            id="address-number-input"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('ADDRESS_NUMBER', true);
                            }}
                            onChange={(val: string) => {
                              // 查詢續保資料
                              // this.handleFetchRenewal(
                              //   values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, val,
                              //   values.ADDRESS_NUMBER_OF, values.ADDRESS_ROADWAY, values.ADDRESS_ALLEY, values.ADDRESS_FLOOR,
                              //   values.ADDRESS_FLOOR_OF
                              // )
                              if (!val) {
                                setFieldValue('ADDRESS_NUMBER_OF', '');
                              }
                              handleChange('ADDRESS_NUMBER')(val);
                            }}
                          />
                          <span>號之</span>
                          <Field
                            component={InputWithRegex}
                            regex={/^[\d]{0,4}$/}
                            name="ADDRESS_NUMBER_OF"
                            tabIndex={8}
                            data-fieldname="ADDRESS_NUMBER_OF"
                            maxLength={4}
                            autoComplete="off"
                            id="address-number-of-input"
                            className="element__input"
                            disabled={!values.ADDRESS_NUMBER || values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('ADDRESS_NUMBER_OF', true);
                            }}
                            onChange={(val: string) => {
                              // 查詢續保資料
                              // this.handleFetchRenewal(
                              //   values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_NUMBER,
                              //   val, values.ADDRESS_ROADWAY, values.ADDRESS_ALLEY, values.ADDRESS_FLOOR,
                              //   values.ADDRESS_FLOOR_OF
                              // )
                              handleChange('ADDRESS_NUMBER_OF')(val);
                            }}
                          />
                          <span>，</span>
                          <Field
                            component={InputWithRegex}
                            name="ADDRESS_FLOOR"
                            tabIndex={9}
                            data-fieldname="ADDRESS_FLOOR"
                            maxLength={3}
                            autoComplete="off"
                            id="address-floor-input"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('ADDRESS_FLOOR', true);
                            }}
                            onChange={(val: string) => {
                              setFieldTouched('CURRENT_FLOOR', true);

                              // 查詢續保資料
                              // this.handleFetchRenewal(
                              //   values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_NUMBER,
                              //   values.ADDRESS_NUMBER_OF, values.ADDRESS_ROADWAY, values.ADDRESS_ALLEY, val,
                              //   values.ADDRESS_FLOOR_OF
                              // )
                              if (!val) {
                                setFieldValue('ADDRESS_FLOOR_OF', '');
                                setFieldValue('CURRENT_FLOOR', '1');
                                setFieldTouched('CURRENT_FLOOR', false);
                                setFieldTouched('FLOOR_TOTAL', false);
                                setFieldTouched('BASEMENT_FLOOR_TOTAL', false);
                              }
                              handleChange('ADDRESS_FLOOR')(val);
                            }}
                          />
                          <span>樓之</span>
                          <Field
                            component={InputWithRegex}
                            name="ADDRESS_FLOOR_OF"
                            tabIndex={10}
                            data-fieldname="ADDRESS_FLOOR_OF"
                            maxLength={3}
                            autoComplete="off"
                            id="address-floor-input"
                            className="element__input"
                            disabled={!values.ADDRESS_FLOOR || values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('ADDRESS_FLOOR_OF', true);
                            }}
                            onChange={(val: string) => {
                              // 查詢續保資料
                              // this.handleFetchRenewal(
                              //   values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_NUMBER,
                              //   values.ADDRESS_NUMBER_OF, values.ADDRESS_ROADWAY, values.ADDRESS_ALLEY, values.ADDRESS_FLOOR,
                              //   val
                              // )
                              handleChange('ADDRESS_FLOOR_OF')(val);
                            }}
                          />
                        </div>
                        <span className="address-preview">
                          {
                            this.handleGetPreveiwAddress(
                              '', values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_ROADWAY,
                              values.ADDRESS_ALLEY, values.ADDRESS_NUMBER, values.ADDRESS_NUMBER_OF, values.ADDRESS_FLOOR,
                              values.ADDRESS_FLOOR_OF
                            )
                          }
                        </span>
                        <div className="element__error-message">
                          {
                            errors.POST_CODE && touched.POST_CODE
                              ? <ErrorMessage name="POST_CODE" />
                              : errors.CITY_ID && touched.CITY_ID
                                ? <ErrorMessage name="CITY_ID" />
                                : errors.AREA_ID && touched.AREA_ID
                                  ? <ErrorMessage name="AREA_ID" />
                                  : errors.STREET_ID && touched.STREET_ID
                                    ? <ErrorMessage name="STREET_ID" />
                                    : errors.ADDRESS_NUMBER && touched.ADDRESS_NUMBER
                                      ? <ErrorMessage name="ADDRESS_NUMBER" />
                                      : errors.ADDRESS_NUMBER_OF && touched.ADDRESS_NUMBER_OF
                                        ? <ErrorMessage name="ADDRESS_NUMBER_OF" />
                                        : errors.ADDRESS_ROADWAY && touched.ADDRESS_ROADWAY
                                          ? <ErrorMessage name="ADDRESS_ROADWAY" />
                                          : errors.ADDRESS_ALLEY && touched.ADDRESS_ALLEY
                                            ? <ErrorMessage name="ADDRESS_ALLEY" />
                                            : errors.ADDRESS_FLOOR && touched.ADDRESS_FLOOR
                                              ? <ErrorMessage name="ADDRESS_FLOOR" />
                                              : errors.ADDRESS_FLOOR_OF && touched.ADDRESS_FLOOR_OF
                                                ? <ErrorMessage name="ADDRESS_FLOOR_OF" />
                                                : ''
                          }
                        </div>
                      </div>
                    </div>
                    <div className="building-info__row">
                      {/* 備註說明 */}
                      <div className="element__form-group" id="address-remark-form-group">
                        <div className="element__form-group-title">備註說明</div>
                        <div className="element__form-group-content">
                          <Field
                            type="text"
                            name="ADDRESS_REMARK"
                            tabIndex={11}
                            maxLength={27}
                            data-fieldname="ADDRESS_REMARK"
                            id="address-remark-input"
                            className="element__input"
                            autoComplete="off"
                            disabled={values.DECLARED === YesNo.Yes}
                          />
                          <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U029)}</p>
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="ADDRESS_REMARK" />
                        </div>
                      </div>
                    </div>
                    <div className="building-info__row">
                      {/* 總樓層數 */}
                      <div
                        className={'element__form-group' + (
                          (errors.FLOOR_TOTAL && touched.FLOOR_TOTAL) ||
                            (errors.CURRENT_FLOOR && touched.CURRENT_FLOOR) ||
                            (errors.BASEMENT_FLOOR_TOTAL && touched.BASEMENT_FLOOR_TOTAL)
                            ? ' element__form-group--invalid'
                            : '')}
                        id="floor-total-form-group"
                      >
                        <div className="element__form-group-title">總樓層數* <span className="floor-total-highlight">{commonService.getCodeMsg(this.props.UICodes, CodeId.U033)}</span></div>
                        <div className="element__form-group-content">
                          <span>地上樓層共</span>
                          <Field
                            component={InputWithRegex}
                            name="FLOOR_TOTAL"
                            tabIndex={12}
                            data-fieldname="FLOOR_TOTAL"
                            maxLength={3}
                            autoComplete="off"
                            id="floor-total-input"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('FLOOR_TOTAL', true);
                            }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              handleChange('FLOOR_TOTAL')(e);
                            }}
                          />
                          <span>層、地下樓層共</span>
                          <Field
                            component={InputWithRegex}
                            name="BASEMENT_FLOOR_TOTAL"
                            tabIndex={13}
                            data-fieldname="BASEMENT_FLOOR_TOTAL"
                            maxLength={2}
                            autoComplete="off"
                            id="basement-floor-select"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('BASEMENT_FLOOR_TOTAL', true);
                            }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              handleChange('BASEMENT_FLOOR_TOTAL')(e);
                            }}
                          />
                          <span>層、所在樓層第</span>
                          <Field
                            component={InputWithRegex}
                            name="CURRENT_FLOOR"
                            tabIndex={14}
                            data-fieldname="CURRENT_FLOOR"
                            maxLength={3}
                            autoComplete="off"
                            id="current-floor-input"
                            className="element__input"
                            disabled={(!this.state.renewalFire && !values.ADDRESS_FLOOR) || values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('CURRENT_FLOOR', true);
                              setFieldTouched('FLOOR_TOTAL', true);
                            }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              handleChange('CURRENT_FLOOR')(e);
                            }}
                          />
                          <span>層</span>
                        </div>
                        <div className="element__error-message">
                          {
                            errors.FLOOR_TOTAL && touched.FLOOR_TOTAL
                              ? <ErrorMessage name="FLOOR_TOTAL" />
                              : errors.CURRENT_FLOOR && touched.CURRENT_FLOOR
                                ? <ErrorMessage name="CURRENT_FLOOR" />
                                : errors.BASEMENT_FLOOR_TOTAL && touched.BASEMENT_FLOOR_TOTAL
                                  ? <ErrorMessage name="BASEMENT_FLOOR_TOTAL" />
                                  : ''
                          }
                        </div>
                      </div>
                    </div>
                    <div className="building-info__row">
                      {/* 使用面積 (含公設) */}
                      <div className={'element__form-group' + (errors.SQUARE && touched.SQUARE ? ' element__form-group--invalid' : '')} id="square-feet-form-group">
                        <div className="element__form-group-title">使用面積 (含公設)*</div>
                        <div className="element__form-group-content">
                          <Field
                            component={InputWithRegex}
                            regex={values.SQUARE_UNIT === SquareType.Feet ? /^[\d]{0,4}(\.[\d]{0,2})?$/ : /^[\d]{0,4}(\.[\d]{0,5})?$/}
                            name="SQUARE"
                            tabIndex={15}
                            data-fieldname="SQUARE"
                            maxLength={values.SQUARE_UNIT === SquareType.Feet ? 7 : 10}
                            autoComplete="off"
                            id="square-feet-input"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('SQUARE', true);
                            }}
                            onChange={(e: any) => {
                              this.handleSquareChange(e, values.SQUARE_UNIT, setFieldValue);
                              handleChange('SQUARE')(e);
                            }}
                          />
                          <div className="element__radio-group">
                            <label htmlFor="square-meter-radio">
                              <div className="element__radio">
                                <Field
                                  type="radio"
                                  name="SQUARE_UNIT"
                                  id="square-meter-radio"
                                  value={SquareType.Meter}
                                  disabled={values.DECLARED === YesNo.Yes}
                                  onClick={(e: React.MouseEvent<HTMLInputElement>) => this.handleSquareUnitClick(e.currentTarget.value, values.SQUARE_UNIT, values.SQUARE, setFieldValue, setFieldTouched)}
                                />
                                <div className="element__radio-btn" />
                              </div>
                              <span>平方公尺</span>
                              {
                                values.SQUARE_UNIT === SquareType.Meter && (
                                  <span className="ant-picker-exam-info">{`(約${values.SQUARE_FEET ? values.SQUARE_FEET : 0}坪)`}</span>
                                )
                              }
                            </label>
                          </div>
                          <div className="element__radio-group">
                            <label htmlFor="square-feet-radio">
                              <div className="element__radio">
                                <Field
                                  type="radio"
                                  name="SQUARE_UNIT"
                                  disabled={values.DECLARED === YesNo.Yes}
                                  id="square-feet-radio"
                                  value={SquareType.Feet}
                                  onClick={(e: React.MouseEvent<HTMLInputElement>) => this.handleSquareUnitClick(e.currentTarget.value, values.SQUARE_UNIT, values.SQUARE, setFieldValue, setFieldTouched)}
                                />
                                <div className="element__radio-btn" />
                              </div>
                              <span>坪</span>
                            </label>
                          </div>
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="SQUARE" />
                        </div>
                      </div>
                      {/* 建築物結構 */}
                      <div className={'element__form-group' + (errors.BUILDING_STRUCTURE && touched.BUILDING_STRUCTURE ? ' element__form-group--invalid' : '')} id="building-structure-form-group">
                        <div className="element__form-group-title">建築物結構*</div>
                        <Field
                          as="select"
                          name="BUILDING_STRUCTURE"
                          tabIndex={16}
                          data-fieldname="BUILDING_STRUCTURE"
                          id="building-structure-select"
                          className="element__select"
                          disabled={values.DECLARED === YesNo.Yes}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            commonService.setSelectOptName(setFieldValue, 'BUILDING_STRUCTURE_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                            if (e.target.value === '99') {
                              sweetAlertService.modal({
                                icon: SweetAlertIcon.Info,
                                html: commonService.getCodeMsg(this.props.UICodes, CodeId.W071)
                              });
                            }
                            handleChange('BUILDING_STRUCTURE')(e);
                          }}
                        >
                          <option value="">請選擇</option>
                          {buildStructOpts}
                        </Field>
                        <div className="element__error-message">
                          <ErrorMessage name="BUILDING_STRUCTURE" />
                        </div>
                      </div>
                      {/* 屋頂別 */}
                      <div className={'element__form-group' + (errors.ROOF_TYPE && touched.ROOF_TYPE ? ' element__form-group--invalid' : '')} id="roof-type-form-group">
                        <div className="element__form-group-title">屋頂別*</div>
                        <Field
                          as="select"
                          name="ROOF_TYPE"
                          tabIndex={17}
                          data-fieldname="ROOF_TYPE"
                          id="roof-type-select"
                          className="element__select"
                          disabled={values.DECLARED === YesNo.Yes}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            commonService.setSelectOptName(setFieldValue, 'ROOF_TYPE_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                            if (e.target.value === '99') {
                              sweetAlertService.modal({
                                icon: SweetAlertIcon.Info,
                                html: commonService.getCodeMsg(this.props.UICodes, CodeId.W072)
                              });
                            }
                            handleChange('ROOF_TYPE')(e);
                          }}
                        >
                          <option value="">請選擇</option>
                          {roofTypeOpts}
                        </Field>
                        <div className="element__error-message">
                          <ErrorMessage name="ROOF_TYPE" />
                        </div>
                      </div>
                    </div>
                    <div className="building-info__row">
                      {/* 建造年份 */}
                      <div className={'element__form-group' + (errors.CONSTRUCTION_YEAR && touched.CONSTRUCTION_YEAR ? ' element__form-group--invalid' : '')} id="construction-year-form-group">
                        <div className="element__form-group-title">建造年份*</div>
                        <div className="element__form-group-content">
                          <span>民國</span>
                          <Field
                            component={InputWithRegex}
                            name="CONSTRUCTION_YEAR"
                            tabIndex={18}
                            data-fieldname="CONSTRUCTION_YEAR"
                            maxLength={3}
                            autoComplete="off"
                            id="construction-year-input"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            onBlur={() => {
                              setFieldTouched('CONSTRUCTION_YEAR', true);
                            }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              handleChange('CONSTRUCTION_YEAR')(e);
                            }}
                          />
                          <span>年</span>
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="CONSTRUCTION_YEAR" />
                        </div>
                      </div>
                      {/* 同棟樓是否有營業 */}
                      <div className={'element__form-group' + (errors.TRADE && touched.TRADE ? ' element__form-group--invalid' : '')} id="trade-form-group">
                        <div className="element__form-group-title">同棟樓是否有營業*</div>
                        <div className="element__form-group-content" tabIndex={19} data-fieldname="TRADE" style={{ outline: 'none' }}>
                          {handleCreateTradeRadios(values)}
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="TRADE" />
                        </div>
                      </div>
                      {/* 裝潢費用 */}
                      <div className={'element__form-group' + (errors.DECORATION_COST && touched.DECORATION_COST ? ' element__form-group--invalid' : '')} id="decoration-cost-form-group">
                        <div className="element__form-group-title">裝潢費用*</div>
                        <div className="element__form-group-content">
                          <Field
                            as="select"
                            name="DECORATION_COST"
                            tabIndex={20}
                            data-fieldname="DECORATION_COST"
                            id="decoration-cost-select"
                            className="element__select"
                            disabled={values.DECLARED === YesNo.Yes}
                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                              commonService.setSelectOptName(setFieldValue, 'DECORATION_COST_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                              handleChange('DECORATION_COST')(e);
                            }}
                          >
                            <option value="">請選擇</option>
                            {this.state.decoCostSysOpts.map((sysOpt: SysOption, index: number) => {
                              return <option key={index} value={sysOpt.PARAM_VALUE}>{sysOpt.PARAM_TEXT}</option>;
                            })}
                          </Field>
                          <span>/坪</span>
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="DECORATION_COST" />
                        </div>
                      </div>
                    </div>
                    <div className="building-info__row">
                      {/* 投保起日 */}
                      <div className={'element__form-group' + (errors.INSURED_DATE && touched.INSURED_DATE ? ' element__form-group--invalid' : '')} id="insured-date-form-group">
                        <div className="element__form-group-title">投保起日* <span className="ant-picker-exam-info">範例： 2020/01/01</span></div>
                        <div className="element__form-group-content">
                          <DatePicker
                            name="INSURED_DATE"
                            tabIndex={21}
                            data-fieldname="INSURED_DATE"
                            className="element__input"
                            disabled={values.DECLARED === YesNo.Yes}
                            format="YYYY/MM/DD"
                            showToday={false}
                            onFocus={async () => await this.getSysTime()}
                            disabledDate={(current: any) => {
                              const dayShift = moment.unix(this.state.sysTime).hour() >= 12 ? 1 : 0;
                              const nzDate = commonService.normalizeTime(current.format('YYYY-MM-DD'), this.state.sysTime);
                              return nzDate < moment.unix(this.state.sysTime).add(dayShift, 'd') || (nzDate > moment.unix(this.state.sysTime).add(60, 'd'));
                              // return current < moment().add(addDate, 'd') || (current > moment().add(60, 'd'));
                            }}
                            onChange={async (val: any) => {
                              // eslint-disable-next-line no-unused-expressions
                              this?.formikRef?.current?.setFieldValue('DECORATION_COST', '');
                              const selectedDate = moment(val);
                              if (selectedDate.isBefore(referenceDate)) {
                                this.setState(prev => ({
                                  ...prev,
                                  decoCostSysOpts: decoCostOpts6
                                }));
                              }
                              if (selectedDate.isAfter(referenceDate)) {
                                this.setState(prev => ({
                                  ...prev,
                                  decoCostSysOpts: decoCostOpts10
                                }));
                              }

                              const lastDate = this.formikRef.current?.values.INSURED_DATE;
                              if (this.formikRef.current?.values.REPOLICY_NO !== '') {
                                const htmls: any[] = await service.fetchInitSetting().then(resp => resp.UICodes);
                                sweetAlertService.modal({
                                  icon: SweetAlertIcon.Info,
                                  html: htmls.find((item: any) => item.CODE_ID === 'W076').CODE_VALUE ?? '',
                                  showConfirmButton: true,
                                  showCancelButton: true,
                                  confirmButtonText: '確認',
                                  cancelButtonText: '取消'
                                }).then((res) => {
                                  if (res.value && this.formikRef.current) {
                                    if (val) {
                                      const nzDate = commonService.normalizeTime(val.format('YYYY-MM-DD'), this.state.sysTime);
                                      this.formikRef.current.setFieldValue('INSURED_DATE', nzDate.toISOString());
                                    }
                                  }
                                  if (res.dismiss && this.formikRef.current) {
                                    if (this.formikRef.current.values.INSURED_DATE !== moment(this.state.renewalFire.expirateDate)) {
                                      const nzLastDate = commonService.normalizeTime(lastDate.format('YYYY-MM-DD'), this.state.sysTime);
                                      this.formikRef.current.setFieldValue('INSURED_DATE', nzLastDate);
                                    } else {
                                      this.formikRef.current.setFieldValue('INSURED_DATE', moment(this.state.renewalFire.expirateDate));
                                    }
                                  }
                                });
                              } else {
                                if (this.formikRef.current) {
                                  if (val) {
                                    const nzDate = commonService.normalizeTime(val.format('YYYY-MM-DD'), this.state.sysTime);
                                    this.formikRef.current.setFieldValue('INSURED_DATE', nzDate.toISOString());
                                  }
                                }
                              }
                            }}
                          />
                          <p>投保時間由起保日中午十二時起</p>
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="INSURED_DATE" />
                        </div>
                      </div>
                    </div>
                    <div className="building-info__row">
                      {/* 專案代碼 */}
                      <div className={'element__form-group' + (errors.PROGRAM_ID && touched.PROGRAM_ID ? ' element__form-group--invalid' : '')} id="program-id-form-group">
                        <div className="element__form-group-title">活動代碼/推薦員編 <span>{commonService.htmlParser(commonService.getCodeMsg(this.props.UICodes, CodeId.U044))}</span></div>
                        <Field type="text" name="PROGRAM_ID" tabIndex={22} data-fieldname="PROGRAM_ID" id="program-id-input" className="element__input" autoComplete="off" disabled={values.DECLARED === YesNo.Yes} />
                        <div className="element__error-message">
                          <ErrorMessage name="PROGRAM_ID" />
                        </div>
                      </div>
                    </div>
                    <div className="building-info__row">
                      {/* 要/被保險人是否受監護宣告? */}
                      <div className={'element__form-group' + (errors.DECLARED && touched.DECLARED ? ' element__form-group--invalid' : '')} id="declared-form-group">
                        <div className="element__form-group-title">
                          要/被保險人是否受監護宣告?
                          <span className="element__link" onClick={() => this.props.setGuardianshipStatementModalVisible(true)}>(什麼是監護宣告?)</span>
                        </div>
                        <div className="element__form-group-content" tabIndex={23} data-fieldname="DECLARED">
                          {declareRadios}
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="DECLARED" />
                          {values.DECLARED === YesNo.Yes && (
                            commonService.getCodeMsg(this.props.UICodes, CodeId.W001)
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <FieldArray name="CONTRACTS">
                  {
                    () => (
                      <>
                        {this.handleCreateContractArea(values, setFieldValue)}
                      </>
                    )
                  }
                </FieldArray>
                <div className="building-info__terms">
                  <div className="element__checkbox-group">
                    <label htmlFor="all-checked-checkbox">
                      <div className="element__checkbox">
                        <Field
                          type="checkbox"
                          name="ALL_CONTRACT_CHECKED"
                          id="all-checked-checkbox"
                          disabled={_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT)}
                          onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                            e.currentTarget.checked
                              ? apiCommonService.fetchSysTime().then((res: any) => {
                                setFieldValue('ALL_CONTRACT_CHECKED_TIME', res);
                              })
                              : setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
                            if (e.currentTarget.checked) {
                              // 重置已展開的條款
                              this.setState({
                                termStatus: commonService.resetTermStatus(this.state.termStatus)
                              });
                            }
                          }}
                        />
                        <div className="element__checkbox-btn" />
                      </div>
                      <span className={'agree-all-terms' + (_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT) ? ' grey' : '')}>我已審閱及同意上述條款</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="insure-process-building-info__controls">
                <button type="submit" className="element__button element__button--red" disabled={values.DECLARED === YesNo.Yes || (_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT)) || !values.ALL_CONTRACT_CHECKED}>下一步</button>
              </div>
              <FormikFocusError />
            </Form>
          )}
        </Formik>

        {/* 網路續保身分驗證 Modal */}
        <div className="login-modal login-modal--renewal-auth">
          <Modal
            visible={!!this.state.showRenewalAuthModal}
            confirmButton={false}
            cancelButton={false}
            overlayDismiss={false}
            onCancel={this.handleCloseRenewalAuthModal}
          >
            {this.state.renewalAuthStep === RenewalAuthStep.Identity && (
              <div className="auth-block">
                <div className="auth-block__row">
                  <h3 className="auth-block__title">網路續保身分驗證</h3>
                  <div className={'element__form-group' + (this.state.renewalMemberIdError ? ' element__form-group--invalid' : '')}>
                    <span className="ant-input-affix-wrapper element__antd-input-password">
                      <input
                        type={this.state.renewalMemberIdVisible ? 'text' : 'password'}
                        className="ant-input"
                        placeholder="請輸入要保人身分證字號/居留證號"
                        value={this.state.renewalMemberId || ''}
                        onChange={this.handleRenewalMemberIdChange}
                        onBlur={() => this.setState({
                          renewalMemberIdError: this.getRenewalMemberIdError(this.state.renewalMemberId || '')
                        })}
                        maxLength={10}
                        autoComplete="off"
                      />
                      <span className="ant-input-suffix">
                        <span
                          className="ant-input-password-icon"
                          onClick={() => this.setState({ renewalMemberIdVisible: !this.state.renewalMemberIdVisible })}
                        >
                          {this.state.renewalMemberIdVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                        </span>
                      </span>
                    </span>
                    <div className="element__error-message">{this.state.renewalMemberIdError}</div>
                  </div>
                  <div className={'element__form-group' + (this.state.renewalMobileError ? ' element__form-group--invalid' : '')}>
                    <input
                      type="tel"
                      className="element__input"
                      placeholder="請輸入要保人手機號碼，如0911222333"
                      value={this.state.renewalMobile || ''}
                      onChange={this.handleRenewalMobileChange}
                      onBlur={() => this.setState({
                        renewalMobileError: this.getRenewalMobileError(this.state.renewalMobile || '')
                      })}
                      maxLength={10}
                      autoComplete="off"
                    />
                    <div className="element__error-message">{this.state.renewalMobileError}</div>
                  </div>
                  <button
                    type="button"
                    className="element__button element__button--red"
                    onClick={this.handleRenewalAuthSubmit}
                  >
                    確認
                  </button>
                  <button
                    type="button"
                    className="element__button element__button--black"
                    onClick={this.handleCloseRenewalAuthModal}
                  >
                    取消
                  </button>
                </div>
              </div>
            )}
            {this.state.renewalAuthStep === RenewalAuthStep.OTP && this.state.renewalOtpInfo && (
              <OTPVerificationForm
                memberId={this.state.renewalMemberId || ''}
                otpInfo={this.state.renewalOtpInfo}
                getOTPTime={this.state.renewalGetOTPTime as number}
                UICode={this.props.UICodes}
                onUnavailableAuth={this.handleRenewalAuthGoBack}
                onGoBack={this.handleRenewalAuthGoBack}
                onSubmit={this.handleRenewalVerifyOTP}
                onResentOTP={this.handleRenewalResendOTP}
              />
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGuardianshipStatementModalVisible: (visible: boolean) => dispatch(setGuardianshipStatementModalVisibleAction(visible)),
  dispatchFetchMyFavorite: (memberId: string) => dispatch(fetchMyFavorite(memberId))
});

export default connect(mapStateToProps, mapDispatchToProps)(InsureProcessBuildingInfo);
